import styled from 'styled-components';
import { ThemeColours } from '../../styles/ThemeColours';
import { LoadingStrip } from '../LoadingStrip/LoadingStrip';

export const Wrapper = styled.div`
  display: flex;
  margin: 10px 0px;
  overflow: hidden;
  width: 100%;
`;

export const DotWrapper = styled.div`
  background-color: ${ThemeColours.mono100};
  border-radius: 15px;
  display: inline-block;
  height: 30px;
  margin-inline-end: 20px;
  min-width: 30px;
  overflow: hidden;
  width: 30px;
`;

export const Dot = styled(LoadingStrip)`
  border-radius: 15px;
  display: inline-block;
  height: 30px;
  width: 30px;
`;
